import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { NavBar } from '../components/NavBar';
import { SearchBar } from '../components/SearchBar';
import { TableFilter, Filter } from '../components/TableFilter';
import { Badge } from '../components/SubscriptionAppBadge';
import { Button } from '../components/SubscriptionAppButton';
import { ColumnToggle, Column } from '../components/ColumnToggle';
import { ExportButton } from '../components/ExportButton';
import { BulkTagModal, BulkTagModalTag } from '../components/BulkTagModal';
import { MoreVertical, Mail, Phone, MapPin, AlertCircle, CheckCircle, XCircle, Download, Tag as TagIcon, Send, ArrowUpDown, ArrowUp, ArrowDown, Users, RefreshCw } from 'lucide-react';
// Mock Data
const mockContacts = [{
  id: '1',
  name: 'Sarah Johnson',
  email: 'testdemo9@winery.com',
  phone: '+61 412 345 678',
  address: '14 Collins St, Melbourne, VIC',
  status: 'Active',
  subscriptionTitle: 'Premium Wine Club',
  paymentStatus: 'Current',
  atRisk: false,
  tags: ['VIP', 'Red Wine'],
  latestNote: 'Called about shipping delay',
  source: 'Shopify Checkout',
  memberSince: '2025-03-17',
  nextBilling: '2026-03-11',
  ltv: 2277.0,
  totalOrders: 18,
  lastOrder: '2026-02-11',
  aov: 126.5
}, {
  id: '2',
  name: 'Michael Chen',
  email: 'demov18@winery.com',
  phone: '+61 423 987 654',
  address: '88 Yarraville Rd, Yarraville, VIC',
  status: 'Active',
  subscriptionTitle: 'Standard Box',
  paymentStatus: 'Failed',
  atRisk: true,
  tags: ['New Customer', 'Retry'],
  latestNote: 'Payment retry 2/4 — insufficient funds',
  source: 'Shopify Checkout',
  memberSince: '2025-03-17',
  nextBilling: '2026-03-13',
  ltv: 1326.5,
  totalOrders: 7,
  lastOrder: '2025-12-13',
  aov: 189.5
}, {
  id: '3',
  name: 'Emma Williams',
  email: 'demov211@winery.com',
  phone: '+61 408 456 789',
  address: '22 Rundle Mall, Adelaide, SA',
  status: 'Paused',
  subscriptionTitle: 'Premium Wine Club',
  paymentStatus: 'Current',
  atRisk: false,
  tags: ['Seasonal'],
  latestNote: 'Paused for overseas travel',
  source: 'Shopify Checkout',
  memberSince: '2025-03-17',
  nextBilling: '2026-03-16',
  ltv: 2940.0,
  totalOrders: 12,
  lastOrder: '2025-12-16',
  aov: 245.0
}, {
  id: '4',
  name: 'James Anderson',
  email: 'james.a@winery.com',
  phone: '+61 411 222 333',
  address: '5 George St, Sydney, NSW',
  status: 'Active',
  subscriptionTitle: 'Premium Wine Club',
  paymentStatus: 'Failed',
  atRisk: true,
  tags: ['At Risk', 'High Value'],
  latestNote: 'Final retry — card declined',
  source: 'Shopify Checkout',
  memberSince: '2025-03-18',
  nextBilling: '2026-03-19',
  ltv: 1260.0,
  totalOrders: 4,
  lastOrder: '2025-09-19',
  aov: 315.0
}, {
  id: '5',
  name: 'Olivia Martinez',
  email: 'olivia.m@winery.com',
  phone: '+61 477 888 999',
  address: '31 Queen St, Brisbane, QLD',
  status: 'Active',
  subscriptionTitle: 'Premium Wine Club',
  paymentStatus: 'Current',
  atRisk: false,
  tags: ['VIP', 'Loyal'],
  latestNote: 'Loves the Pinot Noir selection',
  source: 'Referral',
  memberSince: '2025-03-19',
  nextBilling: '2026-03-22',
  ltv: 2172.5,
  totalOrders: 22,
  lastOrder: '2025-12-22',
  aov: 98.75
}, {
  id: '6',
  name: 'William Taylor',
  email: 'w.taylor@winery.com',
  phone: '+61 499 111 222',
  address: '7 St Georges Tce, Perth, WA',
  status: 'Paused',
  subscriptionTitle: 'Premium Wine Club',
  paymentStatus: 'Failed',
  atRisk: true,
  tags: ['Corporate', 'At Risk'],
  latestNote: 'Payment method revoked — awaiting new card',
  source: 'Manual',
  memberSince: '2025-03-20',
  nextBilling: '2026-03-25',
  ltv: 2479.5,
  totalOrders: 9,
  lastOrder: '2025-09-25',
  aov: 275.5
}, {
  id: '7',
  name: 'Sophia Brown',
  email: 'sophia.b@winery.com',
  phone: '+61 438 555 666',
  address: '19 Elizabeth St, Hobart, TAS',
  status: 'Active',
  subscriptionTitle: 'Premium Wine Club',
  paymentStatus: 'Current',
  atRisk: false,
  tags: ['Premium'],
  latestNote: 'Requested more white wine options',
  source: 'Shopify Checkout',
  memberSince: '2025-03-21',
  nextBilling: '2026-03-28',
  ltv: 2130.0,
  totalOrders: 15,
  lastOrder: '2026-02-28',
  aov: 142.0
}, {
  id: '8',
  name: 'Liam Wilson',
  email: 'liam.w@winery.com',
  phone: '+61 402 333 444',
  address: '45 Northbourne Ave, Canberra, ACT',
  status: 'Cancelled',
  subscriptionTitle: 'Standard Box',
  paymentStatus: 'Current',
  atRisk: false,
  tags: ['Churned'],
  latestNote: 'Cancelled — too expensive',
  source: 'Shopify Checkout',
  memberSince: '2025-03-22',
  nextBilling: '-',
  ltv: 1095.0,
  totalOrders: 3,
  lastOrder: '2025-09-22',
  aov: 365.0
}, {
  id: '9',
  name: 'Isabella Garcia',
  email: 'isabella.g@winery.com',
  phone: '+61 455 777 888',
  address: '12 Cavill Ave, Gold Coast, QLD',
  status: 'Active',
  subscriptionTitle: 'Premium Wine Club',
  paymentStatus: 'Failed',
  atRisk: true,
  tags: ['Loyal', 'Retry'],
  latestNote: 'Card expired — retry 1/4 scheduled',
  source: 'Referral',
  memberSince: '2025-03-23',
  nextBilling: '2026-04-03',
  ltv: 3125.0,
  totalOrders: 20,
  lastOrder: '2026-01-03',
  aov: 156.25
}, {
  id: '10',
  name: 'Noah Rodriguez',
  email: 'noah.r@winery.com',
  phone: '+61 467 888 999',
  address: '28 Hunter St, Newcastle, NSW',
  status: 'Active',
  subscriptionTitle: 'Premium Wine Club',
  paymentStatus: 'Current',
  atRisk: false,
  tags: ['New Customer'],
  latestNote: 'First 6-month subscription',
  source: 'Shopify Checkout',
  memberSince: '2025-03-24',
  nextBilling: '2026-04-05',
  ltv: 2315.5,
  totalOrders: 11,
  lastOrder: '2025-10-05',
  aov: 210.5
}, {
  id: '11',
  name: 'Ava Lee',
  email: 'ava.lee@winery.com',
  phone: '+61 421 999 000',
  address: '3 Moorabool St, Geelong, VIC',
  status: 'Paused',
  subscriptionTitle: 'Premium Wine Club',
  paymentStatus: 'Current',
  atRisk: false,
  tags: ['VIP', 'Loyal'],
  latestNote: 'Paused — moving house',
  source: 'Shopify Checkout',
  memberSince: '2025-03-25',
  nextBilling: '2026-04-08',
  ltv: 4625.0,
  totalOrders: 25,
  lastOrder: '2026-01-08',
  aov: 185.0
}, {
  id: '12',
  name: 'Ethan White',
  email: 'ethan.w@winery.com',
  phone: '+61 434 111 222',
  address: '56 Crown St, Wollongong, NSW',
  status: 'Active',
  subscriptionTitle: 'Premium Wine Club',
  paymentStatus: 'Failed',
  atRisk: true,
  tags: ['At Risk', 'High Value'],
  latestNote: 'Bank declined — retry 3/4 overdue',
  source: 'Shopify Checkout',
  memberSince: '2025-03-26',
  nextBilling: '2026-04-11',
  ltv: 1792.5,
  totalOrders: 6,
  lastOrder: '2025-10-11',
  aov: 298.75
}, {
  id: '13',
  name: 'Mia Harris',
  email: 'mia.h@winery.com',
  phone: '+61 448 222 333',
  address: '9 Abbott St, Cairns, QLD',
  status: 'Active',
  subscriptionTitle: 'Standard Box',
  paymentStatus: 'Current',
  atRisk: false,
  tags: ['Seasonal'],
  latestNote: 'Enjoys the monthly variety',
  source: 'Shopify Checkout',
  memberSince: '2025-03-27',
  nextBilling: '2026-04-14',
  ltv: 1610.0,
  totalOrders: 14,
  lastOrder: '2026-03-14',
  aov: 115.0
}, {
  id: '14',
  name: 'Lucas Martin',
  email: 'lucas.m@winery.com',
  phone: '+61 412 333 444',
  address: '17 Flinders St, Townsville, QLD',
  status: 'Active',
  subscriptionTitle: 'Standard Box',
  paymentStatus: 'Current',
  atRisk: false,
  tags: [],
  latestNote: 'No issues reported',
  source: 'Shopify Checkout',
  memberSince: '2025-03-28',
  nextBilling: '2026-04-17',
  ltv: 1804.0,
  totalOrders: 8,
  lastOrder: '2026-01-17',
  aov: 225.5
}, {
  id: '15',
  name: 'Charlotte Thompson',
  email: 'charlotte.t@winery.com',
  phone: '+61 489 444 555',
  address: '41 Mitchell St, Darwin, NT',
  status: 'Paused',
  subscriptionTitle: 'Premium Wine Club',
  paymentStatus: 'Failed',
  atRisk: true,
  tags: ['Corporate', 'High Value'],
  latestNote: 'On hold — awaiting customer action',
  source: 'Manual',
  memberSince: '2025-03-29',
  nextBilling: '2026-04-20',
  ltv: 4358.25,
  totalOrders: 13,
  lastOrder: '2026-01-20',
  aov: 335.25
}, {
  id: '16',
  name: 'Mason Jackson',
  email: 'mason.j@winery.com',
  phone: '+61 456 555 666',
  address: '8 Sturt St, Ballarat, VIC',
  status: 'Cancelled',
  subscriptionTitle: 'Premium Wine Club',
  paymentStatus: 'Current',
  atRisk: false,
  tags: ['Churned'],
  latestNote: 'Cancelled — switching to competitor',
  source: 'POS',
  memberSince: '2025-03-30',
  nextBilling: '-',
  ltv: 1900.0,
  totalOrders: 5,
  lastOrder: '2025-11-23',
  aov: 380.0
}, {
  id: '17',
  name: 'Amelia Clark',
  email: 'amelia.c@winery.com',
  phone: '+61 423 666 777',
  address: '25 Pall Mall, Bendigo, VIC',
  status: 'Active',
  subscriptionTitle: 'Premium Wine Club',
  paymentStatus: 'Current',
  atRisk: false,
  tags: ['Loyal', 'Premium'],
  latestNote: 'Long-time member — very satisfied',
  source: 'Referral',
  memberSince: '2025-03-31',
  nextBilling: '2026-04-26',
  ltv: 1705.25,
  totalOrders: 19,
  lastOrder: '2026-01-26',
  aov: 89.75
}, {
  id: '18',
  name: 'Benjamin Lewis',
  email: 'benjamin.l@winery.com',
  phone: '+61 445 777 888',
  address: '33 Brisbane St, Launceston, TAS',
  status: 'Active',
  subscriptionTitle: 'Premium Wine Club',
  paymentStatus: 'Current',
  atRisk: false,
  tags: ['New Customer'],
  latestNote: 'Signed up for 6-month plan',
  source: 'Shopify Checkout',
  memberSince: '2025-04-01',
  nextBilling: '2026-04-29',
  ltv: 1675.0,
  totalOrders: 10,
  lastOrder: '2025-10-29',
  aov: 167.5
}, {
  id: '19',
  name: 'Harper Walker',
  email: 'harper.w@winery.com',
  phone: '+61 478 888 999',
  address: '62 Ruthven St, Toowoomba, QLD',
  status: 'Paused',
  subscriptionTitle: 'Premium Wine Club',
  paymentStatus: 'Current',
  atRisk: false,
  tags: ['Premium'],
  latestNote: 'Paused for holiday season',
  source: 'Shopify Checkout',
  memberSince: '2025-04-02',
  nextBilling: '2026-05-02',
  ltv: 4032.0,
  totalOrders: 16,
  lastOrder: '2026-04-02',
  aov: 252.0
}, {
  id: '20',
  name: 'Alexander Hall',
  email: 'alex.h@winery.com',
  phone: '+61 401 999 000',
  address: '15 Dean St, Albury, NSW',
  status: 'Active',
  subscriptionTitle: 'Standard Box',
  paymentStatus: 'Current',
  atRisk: false,
  tags: ['New Customer'],
  latestNote: 'Brand new subscriber',
  source: 'Shopify Checkout',
  memberSince: '2025-04-03',
  nextBilling: '2026-05-12',
  ltv: 75.25,
  totalOrders: 1,
  lastOrder: '2025-04-03',
  aov: 75.25
}, {
  id: '21',
  name: 'Victoria Moore',
  email: 'victoria.m@winery.com',
  phone: '+61 432 000 111',
  address: '29 Market St, Fremantle, WA',
  status: 'Active',
  subscriptionTitle: 'Premium Wine Club',
  paymentStatus: 'Failed',
  atRisk: true,
  tags: ['At Risk', 'Loyal'],
  latestNote: 'Card blocked by bank — needs new payment method',
  source: 'Shopify Checkout',
  memberSince: '2025-04-04',
  nextBilling: '2026-05-22',
  ltv: 3315.0,
  totalOrders: 17,
  lastOrder: '2026-02-22',
  aov: 195.0
}, {
  id: '22',
  name: 'Daniel Scott',
  email: 'daniel.s@winery.com',
  phone: '+61 467 111 222',
  address: '44 Ocean St, Sunshine Coast, QLD',
  status: 'Active',
  subscriptionTitle: 'Premium Wine Club',
  paymentStatus: 'Current',
  atRisk: true,
  tags: ['At Risk'],
  latestNote: 'Card expiring soon — needs attention',
  source: 'Shopify Checkout',
  memberSince: '2025-04-05',
  nextBilling: '2026-06-01',
  ltv: 2284.0,
  totalOrders: 8,
  lastOrder: '2025-12-01',
  aov: 285.5
}];
export function ContactsPage() {
  const navigate = useNavigate();
  // State
  const [isContactsSynced, setIsContactsSynced] = useState(false);
  const [isSyncing, setIsSyncing] = useState(false);
  const [syncProgress, setSyncProgress] = useState(0);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedContacts, setSelectedContacts] = useState<Set<string>>(new Set());
  // Bulk Tag Modal State
  const [isBulkTagModalOpen, setIsBulkTagModalOpen] = useState(false);
  // Tag color mapping - store colors for all tags
  const [tagColors, setTagColors] = useState<Map<string, string>>(new Map([['VIP', 'purple'], ['Red Wine', 'blue'], ['White Wine', 'blue'], ['At Risk', 'orange'], ['Retry', 'orange'], ['Churned', 'gray'], ['Referral', 'green'], ['New Customer', 'blue'], ['Seasonal', 'green'], ['Loyal', 'purple'], ['Corporate', 'gray'], ['High Value', 'purple'], ['Premium', 'blue']]));
  // Contact data state (so we can update it)
  const [contacts, setContacts] = useState(mockContacts);
  // Sorting state
  const [sortConfig, setSortConfig] = useState<{
    key: string;
    direction: 'asc' | 'desc';
  } | null>(null);
  // Column state - now using Column[] format for ColumnToggle
  const [columns, setColumns] = useState<Column[]>([{
    id: 'contact',
    label: 'Contact',
    visible: true
  }, {
    id: 'phone',
    label: 'Phone',
    visible: true
  }, {
    id: 'address',
    label: 'Address',
    visible: true
  }, {
    id: 'status',
    label: 'Status',
    visible: true
  }, {
    id: 'subscription',
    label: 'Subscription',
    visible: true
  }, {
    id: 'payment',
    label: 'Payment',
    visible: true
  }, {
    id: 'atRisk',
    label: 'At Risk',
    visible: true
  }, {
    id: 'tags',
    label: 'Tags',
    visible: true
  }, {
    id: 'note',
    label: 'Note',
    visible: true
  }, {
    id: 'source',
    label: 'Source',
    visible: false
  }, {
    id: 'memberSince',
    label: 'Member Since',
    visible: false
  }, {
    id: 'nextBilling',
    label: 'Next Billing',
    visible: false
  }, {
    id: 'ltv',
    label: 'LTV',
    visible: false
  }, {
    id: 'totalOrders',
    label: 'Total Orders',
    visible: false
  }, {
    id: 'lastOrder',
    label: 'Last Order',
    visible: false
  }, {
    id: 'aov',
    label: 'AOV',
    visible: false
  }]);
  // Filter state
  const [filterValues, setFilterValues] = useState<Record<string, string[]>>({
    status: [],
    paymentStatus: [],
    atRisk: [],
    subscription: [],
    source: [],
    tags: [],
    contact: [],
    phone: [],
    address: [],
    memberSince: [],
    nextBilling: [],
    ltv: [],
    totalOrders: [],
    lastOrder: [],
    aov: [],
    note: []
  });
  const [openFilterDropdowns, setOpenFilterDropdowns] = useState<Set<string>>(new Set());
  const [addedFilters, setAddedFilters] = useState<Set<string>>(new Set());
  // Get visible columns in order
  const visibleColumns = useMemo(() => {
    return columns.filter(col => col.visible);
  }, [columns]);
  // Available filters
  const availableFilters: Filter[] = [{
    id: 'contact',
    label: 'Contact',
    options: [],
    selectedValue: filterValues.contact?.[0] || '',
    type: 'search',
    isOpen: openFilterDropdowns.has('contact')
  }, {
    id: 'phone',
    label: 'Phone',
    options: [],
    selectedValue: filterValues.phone?.[0] || '',
    type: 'search',
    isOpen: openFilterDropdowns.has('phone')
  }, {
    id: 'address',
    label: 'Address',
    options: [],
    selectedValue: filterValues.address?.[0] || '',
    type: 'search',
    isOpen: openFilterDropdowns.has('address')
  }, {
    id: 'status',
    label: 'Status',
    options: [{
      id: '1',
      label: 'Active',
      value: 'Active'
    }, {
      id: '2',
      label: 'Paused',
      value: 'Paused'
    }, {
      id: '3',
      label: 'Cancelled',
      value: 'Cancelled'
    }],
    selectedValues: filterValues.status || [],
    multiSelect: true,
    isOpen: openFilterDropdowns.has('status')
  }, {
    id: 'subscription',
    label: 'Subscription',
    options: [{
      id: '1',
      label: 'Premium Wine Club',
      value: 'Premium Wine Club'
    }, {
      id: '2',
      label: 'Standard Box',
      value: 'Standard Box'
    }, {
      id: '3',
      label: 'Starter Pack',
      value: 'Starter Pack'
    }],
    selectedValues: filterValues.subscription || [],
    multiSelect: true,
    isOpen: openFilterDropdowns.has('subscription')
  }, {
    id: 'paymentStatus',
    label: 'Payment',
    options: [{
      id: '1',
      label: 'Current',
      value: 'Current'
    }, {
      id: '2',
      label: 'Failed',
      value: 'Failed'
    }],
    selectedValues: filterValues.paymentStatus || [],
    multiSelect: true,
    isOpen: openFilterDropdowns.has('paymentStatus')
  }, {
    id: 'atRisk',
    label: 'At Risk',
    options: [{
      id: '1',
      label: 'Yes',
      value: 'true'
    }, {
      id: '2',
      label: 'No',
      value: 'false'
    }],
    selectedValues: filterValues.atRisk || [],
    multiSelect: true,
    isOpen: openFilterDropdowns.has('atRisk')
  }, {
    id: 'tags',
    label: 'Tags',
    options: [{
      id: '1',
      label: 'VIP',
      value: 'VIP'
    }, {
      id: '2',
      label: 'Red Wine',
      value: 'Red Wine'
    }, {
      id: '3',
      label: 'White Wine',
      value: 'White Wine'
    }, {
      id: '4',
      label: 'At Risk',
      value: 'At Risk'
    }, {
      id: '5',
      label: 'Retry',
      value: 'Retry'
    }, {
      id: '6',
      label: 'Churned',
      value: 'Churned'
    }, {
      id: '7',
      label: 'Referral',
      value: 'Referral'
    }, {
      id: '8',
      label: 'New Customer',
      value: 'New Customer'
    }, {
      id: '9',
      label: 'Seasonal',
      value: 'Seasonal'
    }, {
      id: '10',
      label: 'Loyal',
      value: 'Loyal'
    }, {
      id: '11',
      label: 'Corporate',
      value: 'Corporate'
    }, {
      id: '12',
      label: 'High Value',
      value: 'High Value'
    }, {
      id: '13',
      label: 'Premium',
      value: 'Premium'
    }],
    selectedValues: filterValues.tags || [],
    multiSelect: true,
    isOpen: openFilterDropdowns.has('tags')
  }, {
    id: 'note',
    label: 'Note',
    options: [],
    selectedValue: filterValues.note?.[0] || '',
    type: 'search',
    isOpen: openFilterDropdowns.has('note')
  }, {
    id: 'source',
    label: 'Source',
    options: [{
      id: '1',
      label: 'Shopify Checkout',
      value: 'Shopify Checkout'
    }, {
      id: '2',
      label: 'Manual',
      value: 'Manual'
    }, {
      id: '3',
      label: 'POS',
      value: 'POS'
    }, {
      id: '4',
      label: 'Referral',
      value: 'Referral'
    }],
    selectedValues: filterValues.source || [],
    multiSelect: true,
    isOpen: openFilterDropdowns.has('source')
  }, {
    id: 'memberSince',
    label: 'Member Since',
    options: [],
    selectedValue: filterValues.memberSince?.[0] || '',
    type: 'search',
    isOpen: openFilterDropdowns.has('memberSince')
  }, {
    id: 'nextBilling',
    label: 'Next Billing',
    options: [],
    selectedValue: filterValues.nextBilling?.[0] || '',
    type: 'search',
    isOpen: openFilterDropdowns.has('nextBilling')
  }, {
    id: 'ltv',
    label: 'LTV',
    options: [{
      id: '1',
      label: 'Under $500',
      value: 'under-500'
    }, {
      id: '2',
      label: '$500 - $1000',
      value: '500-1000'
    }, {
      id: '3',
      label: '$1000 - $1500',
      value: '1000-1500'
    }, {
      id: '4',
      label: 'Over $1500',
      value: 'over-1500'
    }],
    selectedValues: filterValues.ltv || [],
    multiSelect: true,
    isOpen: openFilterDropdowns.has('ltv')
  }, {
    id: 'totalOrders',
    label: 'Total Orders',
    options: [{
      id: '1',
      label: '1-5 orders',
      value: '1-5'
    }, {
      id: '2',
      label: '6-10 orders',
      value: '6-10'
    }, {
      id: '3',
      label: '11-15 orders',
      value: '11-15'
    }, {
      id: '4',
      label: '15+ orders',
      value: '15-plus'
    }],
    selectedValues: filterValues.totalOrders || [],
    multiSelect: true,
    isOpen: openFilterDropdowns.has('totalOrders')
  }, {
    id: 'lastOrder',
    label: 'Last Order',
    options: [],
    selectedValue: filterValues.lastOrder?.[0] || '',
    type: 'search',
    isOpen: openFilterDropdowns.has('lastOrder')
  }, {
    id: 'aov',
    label: 'AOV',
    options: [{
      id: '1',
      label: 'Under $75',
      value: 'under-75'
    }, {
      id: '2',
      label: '$75 - $100',
      value: '75-100'
    }, {
      id: '3',
      label: '$100 - $125',
      value: '100-125'
    }, {
      id: '4',
      label: 'Over $125',
      value: 'over-125'
    }],
    selectedValues: filterValues.aov || [],
    multiSelect: true,
    isOpen: openFilterDropdowns.has('aov')
  }];
  // Filter logic
  const filteredContacts = useMemo(() => {
    return contacts.filter(contact => {
      // Search
      if (searchQuery) {
        const query = searchQuery.toLowerCase();
        if (!contact.name.toLowerCase().includes(query) && !contact.email.toLowerCase().includes(query)) {
          return false;
        }
      }
      // Contact Filter (search type)
      if (filterValues.contact && filterValues.contact.length > 0 && filterValues.contact[0].trim()) {
        const searchValue = filterValues.contact[0].toLowerCase();
        if (!contact.name.toLowerCase().includes(searchValue) && !contact.email.toLowerCase().includes(searchValue)) {
          return false;
        }
      }
      // Phone Filter (search type)
      if (filterValues.phone && filterValues.phone.length > 0 && filterValues.phone[0].trim()) {
        const searchValue = filterValues.phone[0].toLowerCase();
        if (!contact.phone.toLowerCase().includes(searchValue)) {
          return false;
        }
      }
      // Address Filter (search type)
      if (filterValues.address && filterValues.address.length > 0 && filterValues.address[0].trim()) {
        const searchValue = filterValues.address[0].toLowerCase();
        if (!contact.address.toLowerCase().includes(searchValue)) {
          return false;
        }
      }
      // Status Filter
      if (filterValues.status?.length > 0 && !filterValues.status.includes(contact.status)) {
        return false;
      }
      // Subscription Filter
      if (filterValues.subscription?.length > 0 && !filterValues.subscription.includes(contact.subscriptionTitle)) {
        return false;
      }
      // Payment Status Filter
      if (filterValues.paymentStatus?.length > 0 && !filterValues.paymentStatus.includes(contact.paymentStatus)) {
        return false;
      }
      // At Risk Filter
      if (filterValues.atRisk?.length > 0) {
        const isAtRisk = contact.atRisk.toString();
        if (!filterValues.atRisk.includes(isAtRisk)) return false;
      }
      // Tags Filter - contact must have at least one of the selected tags
      if (filterValues.tags?.length > 0) {
        const hasMatchingTag = filterValues.tags.some(tag => contact.tags.includes(tag));
        if (!hasMatchingTag) return false;
      }
      // Note Filter (search type)
      if (filterValues.note && filterValues.note.length > 0 && filterValues.note[0].trim()) {
        const searchValue = filterValues.note[0].toLowerCase();
        if (!contact.latestNote.toLowerCase().includes(searchValue)) {
          return false;
        }
      }
      // Source Filter
      if (filterValues.source?.length > 0 && !filterValues.source.includes(contact.source)) {
        return false;
      }
      // Member Since Filter (search type)
      if (filterValues.memberSince && filterValues.memberSince.length > 0 && filterValues.memberSince[0].trim()) {
        const searchValue = filterValues.memberSince[0].toLowerCase();
        if (!contact.memberSince.toLowerCase().includes(searchValue)) {
          return false;
        }
      }
      // Next Billing Filter (search type)
      if (filterValues.nextBilling && filterValues.nextBilling.length > 0 && filterValues.nextBilling[0].trim()) {
        const searchValue = filterValues.nextBilling[0].toLowerCase();
        if (!contact.nextBilling.toLowerCase().includes(searchValue)) {
          return false;
        }
      }
      // LTV Filter
      if (filterValues.ltv?.length > 0) {
        const ltvMatch = filterValues.ltv.some(value => {
          if (value === 'under-500') return contact.ltv < 500;
          if (value === '500-1000') return contact.ltv >= 500 && contact.ltv < 1000;
          if (value === '1000-1500') return contact.ltv >= 1000 && contact.ltv < 1500;
          if (value === 'over-1500') return contact.ltv >= 1500;
          return false;
        });
        if (!ltvMatch) return false;
      }
      // Total Orders Filter
      if (filterValues.totalOrders?.length > 0) {
        const ordersMatch = filterValues.totalOrders.some(value => {
          if (value === '1-5') return contact.totalOrders >= 1 && contact.totalOrders <= 5;
          if (value === '6-10') return contact.totalOrders >= 6 && contact.totalOrders <= 10;
          if (value === '11-15') return contact.totalOrders >= 11 && contact.totalOrders <= 15;
          if (value === '15-plus') return contact.totalOrders > 15;
          return false;
        });
        if (!ordersMatch) return false;
      }
      // Last Order Filter (search type)
      if (filterValues.lastOrder && filterValues.lastOrder.length > 0 && filterValues.lastOrder[0].trim()) {
        const searchValue = filterValues.lastOrder[0].toLowerCase();
        if (!contact.lastOrder.toLowerCase().includes(searchValue)) {
          return false;
        }
      }
      // AOV Filter
      if (filterValues.aov?.length > 0) {
        const aovMatch = filterValues.aov.some(value => {
          if (value === 'under-75') return contact.aov < 75;
          if (value === '75-100') return contact.aov >= 75 && contact.aov < 100;
          if (value === '100-125') return contact.aov >= 100 && contact.aov < 125;
          if (value === 'over-125') return contact.aov >= 125;
          return false;
        });
        if (!aovMatch) return false;
      }
      return true;
    });
  }, [searchQuery, filterValues, contacts]);
  // Sorted and filtered contacts
  const sortedAndFilteredContacts = useMemo(() => {
    if (!sortConfig) return filteredContacts;
    const sorted = [...filteredContacts].sort((a, b) => {
      let aValue: any;
      let bValue: any;
      switch (sortConfig.key) {
        case 'contact':
          aValue = a.name;
          bValue = b.name;
          break;
        case 'phone':
          aValue = a.phone;
          bValue = b.phone;
          break;
        case 'address':
          aValue = a.address;
          bValue = b.address;
          break;
        case 'status':
          aValue = a.status;
          bValue = b.status;
          break;
        case 'subscription':
          aValue = a.subscriptionTitle;
          bValue = b.subscriptionTitle;
          break;
        case 'payment':
          aValue = a.paymentStatus;
          bValue = b.paymentStatus;
          break;
        case 'atRisk':
          aValue = a.atRisk ? 1 : 0;
          bValue = b.atRisk ? 1 : 0;
          break;
        case 'source':
          aValue = a.source;
          bValue = b.source;
          break;
        case 'memberSince':
          aValue = new Date(a.memberSince).getTime();
          bValue = new Date(b.memberSince).getTime();
          break;
        case 'nextBilling':
          aValue = a.nextBilling === '-' ? 0 : new Date(a.nextBilling).getTime();
          bValue = b.nextBilling === '-' ? 0 : new Date(b.nextBilling).getTime();
          break;
        case 'ltv':
          aValue = a.ltv;
          bValue = b.ltv;
          break;
        case 'totalOrders':
          aValue = a.totalOrders;
          bValue = b.totalOrders;
          break;
        case 'lastOrder':
          aValue = new Date(a.lastOrder).getTime();
          bValue = new Date(b.lastOrder).getTime();
          break;
        case 'aov':
          aValue = a.aov;
          bValue = b.aov;
          break;
        default:
          return 0;
      }
      if (typeof aValue === 'number' && typeof bValue === 'number') {
        return sortConfig.direction === 'asc' ? aValue - bValue : bValue - aValue;
      }
      if (aValue < bValue) {
        return sortConfig.direction === 'asc' ? -1 : 1;
      }
      if (aValue > bValue) {
        return sortConfig.direction === 'asc' ? 1 : -1;
      }
      return 0;
    });
    return sorted;
  }, [filteredContacts, sortConfig]);
  // Handlers
  const handleSelectAll = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.checked) {
      setSelectedContacts(new Set(sortedAndFilteredContacts.map(c => c.id)));
    } else {
      setSelectedContacts(new Set());
    }
  };
  const handleSelectContact = (id: string) => {
    const newSelected = new Set(selectedContacts);
    if (newSelected.has(id)) {
      newSelected.delete(id);
    } else {
      newSelected.add(id);
    }
    setSelectedContacts(newSelected);
  };
  const handleFilterChange = (filterId: string, value: string | string[]) => {
    setFilterValues(prev => ({
      ...prev,
      [filterId]: Array.isArray(value) ? value : [value]
    }));
  };
  const handleFilterRemove = (filterId: string) => {
    const newAdded = new Set(addedFilters);
    newAdded.delete(filterId);
    setAddedFilters(newAdded);
    setFilterValues(prev => ({
      ...prev,
      [filterId]: []
    }));
  };
  const handleToggleFilterDropdown = (filterId: string) => {
    const newOpen = new Set(openFilterDropdowns);
    if (newOpen.has(filterId)) {
      newOpen.delete(filterId);
    } else {
      newOpen.add(filterId);
    }
    setOpenFilterDropdowns(newOpen);
  };
  const handleAddFilter = (filterId: string) => {
    const newAdded = new Set(addedFilters);
    newAdded.add(filterId);
    setAddedFilters(newAdded);
  };
  // Handle sort
  const handleSort = (columnKey: string) => {
    setSortConfig(current => {
      if (!current || current.key !== columnKey) {
        return {
          key: columnKey,
          direction: 'asc'
        };
      }
      if (current.direction === 'asc') {
        return {
          key: columnKey,
          direction: 'desc'
        };
      }
      return null;
    });
  };
  // Render cell content based on column id
  const renderCell = (contact: (typeof mockContacts)[0], columnId: string) => {
    switch (columnId) {
      case 'contact':
        return <div data-id="element-5698">
            <div className="font-medium text-[#0F172A]" data-id="element-5699">{contact.name}</div>
            <div className="text-xs text-[#64748B]" data-id="element-5700">{contact.email}</div>
          </div>;
      case 'phone':
        return <span className="text-sm text-[#475569] whitespace-nowrap" data-id="element-5701">
            {contact.phone}
          </span>;
      case 'address':
        return <div className="text-sm text-[#475569]" data-id="element-5702">
            <div className="whitespace-nowrap" data-id="element-5703">
              {contact.address.split(',')[0]}
            </div>
            <div className="whitespace-nowrap" data-id="element-5704">
              {contact.address.split(',').slice(1).join(',').trim()}
            </div>
          </div>;
      case 'status':
        return <Badge variant={contact.status === 'Active' ? 'success' : contact.status === 'Paused' ? 'warning' : 'error'} data-id="element-5705">
            {contact.status}
          </Badge>;
      case 'subscription':
        return <span className="text-sm text-[#0F172A] font-medium" data-id="element-5706">
            {contact.subscriptionTitle}
          </span>;
      case 'payment':
        return <Badge variant={contact.paymentStatus === 'Current' ? 'success' : 'error'} data-id="element-5707">
            {contact.paymentStatus}
          </Badge>;
      case 'atRisk':
        return contact.atRisk ? <div className="flex items-center text-[#EF4444] gap-1" data-id="element-5708">
            <AlertCircle className="w-4 h-4" data-id="element-5709" />
            <span className="text-sm font-medium" data-id="element-5710">Yes</span>
          </div> : <span className="text-sm text-[#64748B]" data-id="element-5711">No</span>;
      case 'tags':
        return <div className="flex flex-wrap gap-1" data-id="element-5712">
            {contact.tags.map(tag => {
            const tagColor = tagColors.get(tag) || 'blue';
            // Check if it's a custom hex color
            const isCustomColor = tagColor.startsWith('#');
            if (isCustomColor) {
              // Convert hex to RGB for background with opacity
              const hexToRgb = (hex: string) => {
                const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
                return result ? {
                  r: parseInt(result[1], 16),
                  g: parseInt(result[2], 16),
                  b: parseInt(result[3], 16)
                } : null;
              };
              const rgb = hexToRgb(tagColor);
              if (rgb) {
                return <span key={tag} className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium border" style={{
                  backgroundColor: `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0.15)`,
                  color: tagColor,
                  borderColor: `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0.3)`
                }} data-id="element-5713">
                      {tag}
                    </span>;
              }
            }
            // Use predefined color classes for standard colors
            const colorClasses = {
              blue: 'bg-[#DBEAFE] text-[#1E40AF] border-[#BFDBFE]',
              green: 'bg-[#D1FAE5] text-[#065F46] border-[#A7F3D0]',
              orange: 'bg-[#FED7AA] text-[#C2410C] border-[#FDBA74]',
              purple: 'bg-[#E9D5FF] text-[#6B21A8] border-[#D8B4FE]',
              gray: 'bg-[#F1F5F9] text-[#475569] border-[#CBD5E1]'
            };
            return <span key={tag} className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium border ${colorClasses[tagColor as keyof typeof colorClasses] || colorClasses.blue}`} data-id="element-5714">
                  {tag}
                </span>;
          })}
          </div>;
      case 'note':
        return <span className="text-sm text-[#64748B] truncate max-w-[100px]" data-id="element-5715">
            {contact.latestNote}
          </span>;
      case 'source':
        return <span className="text-sm text-[#475569]" data-id="element-5716">{contact.source}</span>;
      case 'memberSince':
        return <span className="text-sm text-[#475569]" data-id="element-5717">{contact.memberSince}</span>;
      case 'nextBilling':
        return <span className="text-sm text-[#475569]" data-id="element-5718">{contact.nextBilling}</span>;
      case 'ltv':
        return <span className="text-sm text-[#0F172A] font-medium" data-id="element-5719">
            ${contact.ltv.toFixed(2)}
          </span>;
      case 'totalOrders':
        return <span className="text-sm text-[#475569]" data-id="element-5720">{contact.totalOrders}</span>;
      case 'lastOrder':
        return <span className="text-sm text-[#475569]" data-id="element-5721">{contact.lastOrder}</span>;
      case 'aov':
        return <span className="text-sm text-[#475569]" data-id="element-5722">
            ${contact.aov.toFixed(2)}
          </span>;
      default:
        return null;
    }
  };
  // Column definitions for toggle
  const allColumns = [{
    id: 'source',
    label: 'Source'
  }, {
    id: 'memberSince',
    label: 'Member Since'
  }, {
    id: 'nextBilling',
    label: 'Next Billing'
  }, {
    id: 'ltv',
    label: 'LTV'
  }, {
    id: 'totalOrders',
    label: 'Total Orders'
  }, {
    id: 'lastOrder',
    label: 'Last Order'
  }, {
    id: 'aov',
    label: 'AOV'
  }];
  // Available tags for bulk tagging
  const availableBulkTags: BulkTagModalTag[] = [{
    id: 'vip',
    label: 'VIP',
    color: 'purple',
    appliedToCount: 0
  }, {
    id: 'red-wine',
    label: 'Red Wine',
    color: 'blue',
    appliedToCount: 0
  }, {
    id: 'white-wine',
    label: 'White Wine',
    color: 'blue',
    appliedToCount: 0
  }, {
    id: 'at-risk',
    label: 'At Risk',
    color: 'orange',
    appliedToCount: 0
  }, {
    id: 'retry',
    label: 'Retry',
    color: 'orange',
    appliedToCount: 0
  }, {
    id: 'churned',
    label: 'Churned',
    color: 'gray',
    appliedToCount: 0
  }, {
    id: 'referral',
    label: 'Referral',
    color: 'green',
    appliedToCount: 0
  }, {
    id: 'new-customer',
    label: 'New Customer',
    color: 'blue',
    appliedToCount: 0
  }, {
    id: 'seasonal',
    label: 'Seasonal',
    color: 'green',
    appliedToCount: 0
  }, {
    id: 'loyal',
    label: 'Loyal',
    color: 'purple',
    appliedToCount: 0
  }, {
    id: 'corporate',
    label: 'Corporate',
    color: 'gray',
    appliedToCount: 0
  }, {
    id: 'high-value',
    label: 'High Value',
    color: 'purple',
    appliedToCount: 0
  }, {
    id: 'premium',
    label: 'Premium',
    color: 'blue',
    appliedToCount: 0
  }].map(tag => {
    // Calculate how many selected contacts have this tag - use 'contacts' state instead of 'mockContacts'
    const appliedCount = Array.from(selectedContacts).filter(contactId => {
      const contact = contacts.find(c => c.id === contactId);
      return contact?.tags.includes(tag.label);
    }).length;
    return {
      ...tag,
      appliedToCount: appliedCount
    };
  });
  // Handle bulk tag apply
  const handleBulkTagApply = (tagsToAdd: string[], tagsToRemove: string[], newTagsWithColors?: Map<string, {
    label: string;
    color: string;
  }>) => {
    console.log('=== BULK TAG APPLY DEBUG ===');
    console.log('Applying tags to', selectedContacts.size, 'contacts');
    console.log('Selected contact IDs:', Array.from(selectedContacts));
    console.log('Tags to add:', tagsToAdd);
    console.log('Tags to remove:', tagsToRemove);
    console.log('New tags with colors:', newTagsWithColors);
    // Update tag colors map with newly created tags
    if (newTagsWithColors && newTagsWithColors.size > 0) {
      setTagColors(prevColors => {
        const newColors = new Map(prevColors);
        newTagsWithColors.forEach((tagData, tagId) => {
          console.log(`Adding color mapping: ${tagData.label} -> ${tagData.color}`);
          newColors.set(tagData.label, tagData.color);
        });
        return newColors;
      });
    }
    // Update contacts with new tags
    setContacts(prevContacts => {
      const updatedContacts = prevContacts.map(contact => {
        if (!selectedContacts.has(contact.id)) {
          return contact;
        }
        console.log(`Processing contact ${contact.id} (${contact.name})`);
        console.log('  Current tags:', contact.tags);
        // Start with existing tags
        let updatedTags = [...contact.tags];
        // Remove tags
        updatedTags = updatedTags.filter(tag => {
          const tagId = tag.toLowerCase().replace(/\s+/g, '-');
          return !tagsToRemove.includes(tagId);
        });
        // Add new tags
        tagsToAdd.forEach(tagId => {
          // Check if it's a newly created tag
          const newTag = newTagsWithColors?.get(tagId);
          const tagLabel = newTag?.label || availableBulkTags.find(t => t.id === tagId)?.label || tagId.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
          console.log(`  Adding tag: ${tagId} -> ${tagLabel}`);
          // Only add if not already present
          if (!updatedTags.includes(tagLabel)) {
            updatedTags.push(tagLabel);
          }
        });
        console.log('  Updated tags:', updatedTags);
        return {
          ...contact,
          tags: updatedTags
        };
      });
      console.log('=== CONTACTS UPDATED ===');
      return updatedContacts;
    });
    // Close modal and clear selection
    setIsBulkTagModalOpen(false);
    setSelectedContacts(new Set());
  };
  return <div className="bg-[#F1F5F9] min-h-full p-4 md:p-6" data-id="element-5723">
      <div className="mb-4 md:mb-6" data-id="element-5724">
        <NavBar tabs={[]} title="Contacts" data-id="element-5725" />
      </div>

      {/* Filter Bar */}
      <div className="bg-white border border-[#E2E8F0] rounded-lg mb-4 md:mb-6 p-4 md:p-6 shadow-[0_1px_3px_rgba(15,23,42,0.08)]" data-id="element-5726">
        <div className="flex flex-col gap-4" data-id="element-5727">
          <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-4" data-id="element-5728">
            <div className="w-full lg:w-80 flex-shrink-0" data-id="element-5729">
              <SearchBar placeholder="Search by name or email" value={searchQuery} onChange={setSearchQuery} className="w-full" data-id="element-5730" />
            </div>

            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 flex-shrink-0 w-full sm:w-auto sm:ml-auto" data-id="element-5731">
              {/* Quick Filters */}

              <div className="flex items-center gap-3 w-full sm:w-auto" data-id="element-5732">
                {/* Export Button */}
                <ExportButton variant="contacts" onExport={async type => {
                console.log(`Exporting ${type}`);
              }} data-id="element-5733" />

                <TableFilter filters={availableFilters} onFilterChange={handleFilterChange} onFilterRemove={handleFilterRemove} onToggleDropdown={handleToggleFilterDropdown} addedFilterIds={addedFilters} onAddFilter={handleAddFilter} renderOnlyButton={true} data-id="element-5734" />

                <ColumnToggle columns={columns} onChange={setColumns} data-id="element-5735" />
              </div>
            </div>
          </div>

          {addedFilters.size > 0 && <div className="flex items-center gap-3" data-id="element-5736">
              <TableFilter filters={availableFilters} onFilterChange={handleFilterChange} onFilterRemove={handleFilterRemove} onToggleDropdown={handleToggleFilterDropdown} addedFilterIds={addedFilters} onAddFilter={handleAddFilter} renderOnlyChips={true} data-id="element-5737" />
              <button onClick={() => {
            setFilterValues({
              status: [],
              paymentStatus: [],
              atRisk: [],
              subscription: [],
              source: [],
              tags: [],
              contact: [],
              phone: [],
              address: [],
              memberSince: [],
              nextBilling: [],
              ltv: [],
              totalOrders: [],
              lastOrder: [],
              aov: [],
              note: []
            });
            setAddedFilters(new Set());
            setSearchQuery('');
          }} className="text-[13px] text-[#0EA5E9] hover:text-[#0284C7] font-medium transition-colors" data-id="element-5738">
                Clear all
              </button>
            </div>}
        </div>
      </div>

      {/* Bulk Actions Bar */}
      {selectedContacts.size > 0 && <div className="bg-white border border-[#E2E8F0] rounded-lg px-4 md:px-6 py-3 md:py-4 mb-4 md:mb-6 shadow-[0_1px_3px_rgba(15,23,42,0.08)]" data-id="element-5739">
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3" data-id="element-5740">
            <div className="flex items-center gap-3" data-id="element-5741">
              <span className="text-[13px] md:text-[14px] font-medium text-[#0F172A]" data-id="element-5742">
                {selectedContacts.size}{' '}
                {selectedContacts.size === 1 ? 'contact' : 'contacts'} selected
              </span>
            </div>
            <div className="flex items-center gap-3 w-full sm:w-auto" data-id="element-5743">
              <Button variant="outline" size="md" iconLeft={<TagIcon className="w-4 h-4" data-id="element-5745" />} onClick={() => setIsBulkTagModalOpen(true)} data-id="element-5744">
                Bulk Tag
              </Button>
              <Button variant="outline" size="md" iconLeft={<Send className="w-4 h-4" data-id="element-5747" />} data-id="element-5746">
                Send to Klaviyo
              </Button>
            </div>
          </div>
        </div>}

      {/* Data Table */}
      <div className="bg-white rounded-lg border border-[#E2E8F0] overflow-hidden shadow-[0_1px_3px_rgba(15,23,42,0.08)]" data-id="element-5748">
        <div className="overflow-x-auto" data-id="element-5749">
          <table className="w-full" key={contacts.length} data-id="element-5750">
            <thead className="bg-[#F1F5F9]" data-id="element-5751">
              <tr data-id="element-5752">
                <th className="px-3 md:px-4 py-3 w-12" data-id="element-5753">
                  <div className="flex items-center justify-center" data-id="element-5754">
                    <input type="checkbox" className="w-[18px] h-[18px] rounded border-2 border-[#CBD5E1] text-[#0EA5E9] focus:ring-2 focus:ring-[#0EA5E9] focus:ring-offset-0 cursor-pointer hover:border-[#0EA5E9] transition-colors" checked={selectedContacts.size === sortedAndFilteredContacts.length && sortedAndFilteredContacts.length > 0} onChange={handleSelectAll} data-id="element-5755" />
                  </div>
                </th>
                {visibleColumns.map(column => <th key={column.id} className={`px-3 md:px-4 py-3 text-left text-[12px] font-semibold uppercase tracking-[0.5px] ${column.id === 'contact' ? 'text-[#475569]' : 'text-[#64748B]'}`} data-id="element-5756">
                    <button onClick={() => handleSort(column.id)} className="flex items-center gap-2 hover:text-[#0EA5E9] transition-colors" data-id="element-5757">
                      {column.label}
                      {sortConfig?.key === column.id ? sortConfig.direction === 'asc' ? <ArrowUp className="w-3.5 h-3.5 text-[#0EA5E9]" data-id="element-5758" /> : <ArrowDown className="w-3.5 h-3.5 text-[#0EA5E9]" data-id="element-5759" /> : <ArrowUpDown className="w-3.5 h-3.5 text-[#CBD5E1]" data-id="element-5760" />}
                    </button>
                  </th>)}
              </tr>
            </thead>
            <tbody className="divide-y divide-[#E2E8F0]" data-id="element-5761">
              {sortedAndFilteredContacts.map(contact => <tr key={contact.id} className={`hover:bg-[#F8FAFC] transition-colors cursor-pointer ${selectedContacts.has(contact.id) ? 'bg-[#F0F9FF]' : ''}`} onClick={() => navigate(`/contacts/${contact.id}`)} data-id="element-5762">
                  <td className="px-3 md:px-4 py-3 md:py-4" onClick={e => e.stopPropagation()} data-id="element-5763">
                    <div className="flex items-center justify-center" data-id="element-5764">
                      <input type="checkbox" className="w-[18px] h-[18px] rounded border-2 border-[#CBD5E1] text-[#0EA5E9] focus:ring-2 focus:ring-[#0EA5E9] focus:ring-offset-0 cursor-pointer hover:border-[#0EA5E9] transition-colors" checked={selectedContacts.has(contact.id)} onChange={() => handleSelectContact(contact.id)} data-id="element-5765" />
                    </div>
                  </td>
                  {visibleColumns.map(column => <td key={column.id} className={`px-3 md:px-4 py-3 md:py-4 ${column.id === 'address' ? 'min-w-[180px]' : column.id === 'phone' ? 'min-w-[140px]' : column.id === 'tags' ? 'min-w-[200px]' : ''}`} data-id="element-5766">
                      {renderCell(contact, column.id)}
                    </td>)}
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>

      {/* Pagination */}
      <div className="flex flex-col md:flex-row items-center justify-between gap-4 mt-4 md:mt-6" data-id="element-5767">
        <div className="text-[13px] text-[#64748B]" data-id="element-5768">
          Showing 1-{sortedAndFilteredContacts.length} of{' '}
          {sortedAndFilteredContacts.length} contacts
        </div>
        <div className="flex items-center gap-2" data-id="element-5769">
          <button disabled className="px-4 py-2 border border-[#CBD5E1] rounded-md text-[13px] font-medium text-[#475569] hover:bg-[#F8FAFC] disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200 ease-in-out" data-id="element-5770">
            Previous
          </button>
          <div className="flex items-center gap-1" data-id="element-5771">
            <button className="w-10 h-10 rounded-md text-[13px] font-medium transition-colors duration-200 ease-in-out bg-[#0EA5E9] text-white" data-id="element-5772">
              1
            </button>
          </div>
          <button disabled className="px-4 py-2 border border-[#CBD5E1] rounded-md text-[13px] font-medium text-[#475569] hover:bg-[#F8FAFC] disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200 ease-in-out" data-id="element-5773">
            Next
          </button>
        </div>
      </div>

      {/* Bulk Tag Modal */}
      <BulkTagModal isOpen={isBulkTagModalOpen} onClose={() => setIsBulkTagModalOpen(false)} selectedCount={selectedContacts.size} availableTags={availableBulkTags} onApply={handleBulkTagApply} data-id="element-5774" />
    </div>;
}